import api from './api';

export interface Organization {
  id: string;
  name: string;
  slug: string;
  description?: string;
  logoUrl?: string;
  website?: string;
  isActive: boolean;
  settings?: string;
  createdAt: string;
  updatedAt?: string;
}

export interface OrganizationUser {
  id: string;
  userId: string;
  userName: string;
  roleName: string;
  joinedAt: string;
}

export interface Role {
  id: string;
  name: string;
  level: string;
  description?: string;
}

// Get current organization
export const getCurrentOrganization = async (): Promise<Organization> => {
  const response = await api.get<Organization>('/organizations');
  return response.data;
};

// Update organization
export const updateOrganization = async (id: string, data: Partial<Organization>): Promise<Organization> => {
  const response = await api.put<Organization>(`/organizations/${id}`, data);
  return response.data;
};

// Get organization users
export const getOrganizationUsers = async (): Promise<OrganizationUser[]> => {
  const response = await api.get<OrganizationUser[]>('/organizations/users');
  return response.data;
};

// Get organization roles
export const getOrganizationRoles = async (): Promise<Role[]> => {
  const response = await api.get<Role[]>('/organizations/roles');
  return response.data;
};
